import { ConfidenceTypes } from "../types/index.ts";

export const cleanConfidence = (value: string | string[]) => {
  if (!value) return ConfidenceTypes.DNF;
  const val = Array.isArray(value) ? value[0] : value;

  const cleanValue = val.replace(/['"[\]\s]/g, "");
  return cleanValue as ConfidenceTypes;
};
